import * as Yup from 'yup';

export const cancelRideValidationSchema = Yup.object().shape({
  reasonKey: Yup.string().required('Please select a cancel reason'),
});
